import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import userProfileApi from "@/api-client/api/services/userProfile/userProfile";
import { useUserContext } from "@/contexts/UserContextProvider";

export default function ChangeLocale() {
  const { i18n } = useTranslation();
  const { user } = useUserContext();

  const handleChangeLanguage = async (lng: string) => {
    i18n.changeLanguage(lng);
    try {
      if (user) {
        await userProfileApi.postLanguage({
          language: lng as "en" | "ru" | "lv",
        });
      }
    } catch (error) {
      console.error("Error while changing language:", error);
    }
  };

  return (
    <Select onValueChange={handleChangeLanguage} value={i18n.language}>
      <SelectTrigger className="w-18 h-10 text-black/50 rounded-[100px] text-[14px] pr-4 py-0">
        <SelectValue placeholder="EN" />
      </SelectTrigger>

      <SelectContent className="rounded-[8px]">
        <SelectItem className="cursor-pointer pl-6" value="en">
          EN
        </SelectItem>
        <SelectItem className="cursor-pointer pl-6" value="lv">
          LV
        </SelectItem>
        <SelectItem className="cursor-pointer pl-6" value="ru">
          RU
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
